import { HttpErrorInterface, HttpErrorParams, V8ErrorConstructor } from './types';
import BaseError from './baseerror';
import _ from 'lodash';

class HttpError extends BaseError implements HttpErrorInterface {
	status?: number;
	type?: string;
	textStatus?: string;
	responseText?: string;
	responseURL?: string;
	errorDetails?: object;
	responseType?: string;

	constructor(
		{
			message,
			errorId,
			name = 'HttpError',
			errorDetails,
			details,
			visualisers,
			messageType,
			responseText,
			tag,
			responseURL,
			textStatus,
			responseType,
			status,
			response,
			originalError
		}: HttpErrorParams) {

		super({message, errorId, name, tag, errorDetails, details, visualisers, originalError, messageType});
		Object.setPrototypeOf(this, HttpError.prototype);
		if ('captureStackTrace' in Error) {
			(Error as V8ErrorConstructor).captureStackTrace(this, this.constructor);
		}

		this.textStatus = textStatus;
		this.status = status;

		responseText && (this.responseText = responseText);
		responseURL && (this.responseURL = responseURL);
		// responseType: json, document, blob, text, arraybuffer, ''
		responseType && (this.responseType = responseType);

		if (response instanceof Response) {
			// used with fetch()
			this.textStatus = response.statusText;
			this.status = response.status;
			// type: basic/cors/error/opaque/opaqueredirect
			this.type = response.type;
			this.responseURL = response.url;
		}
	}

	public getPropertiesToLogAsJson(): object | null {
		const results = {
			...this.errorDetails
		};
		return !_.isEmpty(results) ? results : null;
	}

	public getApiErrorId(): number | null {
		let result = null;

		if (this.responseText) {
			try {
				var errorResponse = JSON.parse(this.responseText);
				result = (errorResponse && errorResponse.error && errorResponse.error.errorid) || errorResponse.errorid;
			} catch (err) {
				//silently ignore error
			}
		}

		return result;
	}

	public getPropertiesToLog(): object | null {
		const results = {
			...this.details,
			responseURL: this.responseURL,
			responseText: this.responseText,
			textStatus: this.textStatus,
			type: this.type,
			status: this.status,
			responseType: this.responseType
		};
		return !_.isEmpty(results) ? results : null;
	}
}

export default HttpError;


// WEBPACK FOOTER //
// ./src/errors/httperror.ts